import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

class TraningRegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null || Object.keys(props.location.state.user).length === 0);
        let trainingExists = !(props.location.state == null || props.location.state.training == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            training: trainingExists ? props.location.state.training :
                {
                    Cost: 0.0
                },
            userExists: userExists,
            confirmationEmail: userExists ? props.location.state.user.email : '',
            partID: 1,
            machineID: 1,
            errors: {},
            registrants: [{
                id: 'reg-0',
                firstname: userExists ? props.location.state.user.firstname : '',
                lastname: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                company: '', dietrestrictions: '', errors: {}
            }],
            loading: false,
            loadingTraining: true,
            searchingServiceCall: false
        };

        this.handleFormChange = this.handleFormChange.bind(this);
        this.showExtraData = this.showExtraData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this); 
        this.showButton = this.showButton.bind(this);
    }

    componentDidMount() {

        console.log(this.state);
        let params = new URLSearchParams(window.location.search);
        let eventID = params.get('id');
        axios.get(`${Constants.apiURL}/api/Training/GetTraining`, {
            params: {
                user: this.state.userExists ? this.state.user.user : 'guest',
                eventID: eventID
            }
        }).then(response => {

            if (response.data) {
                this.setState({
                    training: response.data,
                    loadingTraining: false
                });
            }
            else {
                alert("This training link is not active. Please contact marketing@boland.com with questions.");
                this.props.history.push({
                    pathname: '/training',
                    state: {
                        user: this.state.user
                    }
                });

            }
        }).catch ((response) => {
            // ? Show to user that request is failed
            this.setState({ loadingTraining: false });
            alert("This training link is not active. Please contact marketing@boland.com with questions.");
            this.props.history.push({
                pathname: '/training',
                state: {
                    user: this.state.user
                }
            });
        });
    }

    handleRegistrantChange = (event, id) => {
        this.setState((prevState) => {
            let newArrOfDivs = prevState.registrants;
            newArrOfDivs.find((item) => item.id === id)[event.target.name] =
                event.target.value;
            newArrOfDivs.find((item) => item.id === id).errors[event.target.name] = null;
            return { registrants: newArrOfDivs };
        });
    }
    removeRegistrantRow = (id) => {
        if (this.state.registrants.length < 2) { return; }
        this.setState((prevState) => {
            let newArr = prevState.registrants.filter((item) => item.id !== id);
            return { registrants: newArr };
        });
    }
    addRegistrantRow = () => {
        this.setState({
            registrants: [
                ...this.state.registrants,
                { id: 'reg-' + this.state.machineID, firstname: '', lastname: '', email: '', company: '', dietrestrictions: '', errors: {} }
            ],
            machineID: this.state.machineID + 1
        });
    }

    showExtraData() {
        return (
            <div>
                <Row>
                    <Form.Label className="form-header" style={{ padding: '10px 0px 0px 10px', marginBottom: 0 }}>Class Registration:&nbsp;&nbsp;{this.state.training.Name} </Form.Label>
                </Row>
                <Row>
                    <Form.Label style={{ padding: '0px 0px 0px 10px', fontStyle: 'italic', marginBottom: 0 }}><b>Event Date(s):</b> <br className="mobile-only" style={{ display: 'none' }} /> {moment(this.state.training.StartDate).format("MM/DD/YYYY h:mm A")} - {moment(this.state.training.EndDate).format("MM/DD/YYYY h:mm A")}</Form.Label>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Label style={{ marginBottom: 0, fontStyle: 'italic' }}><b>Description: </b>{this.state.training.Description}</Form.Label>
                    </Col>
                </Row>
                <Row>
                    <Form.Label style={{ marginBottom: 0, fontStyle: 'italic' }} ><b>Cost Per Registrant:</b> ${this.state.training.Cost.toFixed(2)}</Form.Label>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Label style={{ marginBottom: 0, fontStyle: 'italic' }}><b>Location: </b>{this.state.training.Location}</Form.Label>
                    </Col>
                </Row>
                <Form.Group as={Row} className="mb-3" >
                    <Col md={5}>
                        <Form.Label style={{
                            padding: '15px 0px 0px 0px', marginBottom: 5, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '16px', color: '#1F419B'
                        }}>Email Address for Registration Confirmation:</Form.Label>
                        <Form.Control type="text" name="confirmationEmail" value={this.state.confirmationEmail} onChange={this.handleFormChange}
                            isInvalid={!!this.state.errors.confirmationEmail} />
                    </Col>
                </Form.Group>
                <Row>
                    <Form.Label style={{
                        padding: '10px 0px 0px 10px', marginBottom: 5, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '16px', color: '#1F419B'
                    }}>Registrant information:</Form.Label>
                </Row>
                <Col md={11}>
                    <hr />
                </Col>
                {this.state.registrants.map((item) => (
                    <div>
                        <Col md={12}>
                            <Form.Group as={Row} className="mb-3" >
                                <Col md={3}>
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" name="firstname" value={item.firstname} onChange={(e) => this.handleRegistrantChange(e, item.id)}
                                        isInvalid={!!item.errors.firstname} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" name="lastname" value={item.lastname} onChange={(e) => this.handleRegistrantChange(e, item.id)}
                                        isInvalid={!!item.errors.lastname} />
                                </Col>
                                <Col md={2}>
                                    <Form.Label>Company</Form.Label>
                                    <Form.Control type="text" name="company" value={item.company} onChange={(e) => this.handleRegistrantChange(e, item.id)}
                                        isInvalid={!!item.errors.company} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control type="text" name="email" value={item.email} onChange={(e) => this.handleRegistrantChange(e, item.id)}
                                        isInvalid={!!item.errors.email} />
                                </Col>
                                <Col md={1} sm={0} xs={0} style={{ alignSelf: 'self-end' }} className="d-none d-sm-block">
                                    <Button hidden={this.state.registrants[0].id == item.id} style={{ backgroundColor: '#EF4139', width: 'auto' }} variant="primary" onClick={() => this.removeRegistrantRow(item.id)}>X</Button>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={2} >Dietary Restrictions</Form.Label>
                                <Col md={9}>
                                    <Form.Control type="text" name="dietrestrictions" value={item.dietrestrictions} onChange={(e) => this.handleRegistrantChange(e, item.id)}
                                        isInvalid={!!item.errors.dietrestrictions} />
                                </Col>
                                <Col md={1} style={{ alignSelf: 'self-end' }} className="d-block d-sm-none">
                                    <Button hidden={this.state.registrants[0].id == item.id} style={{ backgroundColor: '#EF4139', width: 'auto' }} variant="primary" onClick={() => this.removeRegistrantRow(item.id)}>X</Button>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col md={11}>
                            <hr />
                        </Col>
                    </div>
                ))}

            </div>
         );
    }

    handleFormChange(event) {
        let errors = this.state.errors;

        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            confirmationEmail: event.target.value,
            errors
        });
    }

    validate() {
        let errors = {};
        let isValid = true;

        let reg = this.state.registrants;
        for (var index in reg) {
            if (!reg[index]["firstname"]) {
                isValid = false;
                reg[index].errors["firstname"] = "Invalid.";
            }
            if (!reg[index]["lastname"]) {
                isValid = false;
                reg[index].errors["lastname"] = "Invalid.";
            }
            if (!reg[index]["email"] || !String(reg[index]["email"])
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )) {
                isValid = false;
                reg[index].errors["email"] = "Invalid.";
            }
        }


        if (!this.state["confirmationEmail"] || !String(this.state["confirmationEmail"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["confirmationEmail"] = "Invalid email address.";
        }

        this.setState({
            errors: errors,
            registrants: reg
        });

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }
        this.setState({ loading: true });

        console.log(this.state.training);

        axios.get(`${Constants.apiURL}/api/Training/CheckAvailableSeats`, {
            params: {
                user: this.state.user,
                eventID: this.state.training.Id,
                numberSeats: this.state.registrants.length
            }
        }, {
        }).then(response => {
            console.log(response);
            if (response.data && response.data != false) {

                let apiURL = `${Constants.apiURL}/api/Training/createRegistrations`;

                let formData = new FormData();
                formData.append('user', this.state.userExists ? this.state.user.username : 'guest');
                formData.append('eventString', JSON.stringify(this.state.training));
                formData.append('registrants', JSON.stringify(this.state.registrants));
                formData.append('confirmationEmail', this.state.confirmationEmail);

                axios.post(apiURL, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    console.log(response);
                    if (response.data && response.data != false) {
                        this.props.history.push({
                            pathname: "/training_payment",
                            state: {
                                user: this.state.user,
                                event: this.state.training,
                                registrants: this.state.registrants,
                                transaction: response.data,
                                totalCost: (this.state.registrants.length * this.state.training.Cost).toFixed(2)
                            }
                        });
                    }
                    else {
                        alert('Error processing your request');
                    }
                    this.setState({ loading: false });
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    alert('Error processing your request');
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((error) => {
            // ? Show to user that request is failed
            this.setState({ loading: false });
            if (error.response) {
                alert(error.response.data);
            }
            else {
                alert('Error processing your request');
            }
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B', width: 'auto', marginLeft: '10px' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B', width: 'auto', marginLeft:'10px'  }} variant="primary" type="submit">
                Next
            </Button>
        }
    }
    onTableChange() { }

    render() {
        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            onSelect: this.handleOnSelect,
            selected: this.state.selectedRow,
            style: { backgroundColor: 'rgba(0,0,0,.2)' },
            clickToSelect: true
        };

        return (
            <div>
                {this.state.userExists ? <SiteMenu user={this.state.user} currentPage='trainingRegistration' /> : <GuestSiteMenu currentPage='trainingRegistration' />}
                <div style={{ textAlign: 'center', marginTop: '50px' }}
                    hidden={!this.state.loadingTraining}>
                <Spinner
                    style={{ verticalAlign:'center', width: "4rem", height: "4rem" }}
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                </div>
                <Form onSubmit={this.handleSubmit} noValidate style={{ margin: 10 }} hidden={this.state.loadingTraining}>
                    <Row>
                        {this.showExtraData()}
                        <Row>
                            <Col md={11} style={{ textAlign: 'end', marginTop:'10px' }}>
                                <Button style={{ backgroundColor: '#1F419B', width: 'auto' }} variant="primary" onClick={() => this.addRegistrantRow()}>Add registrant</Button>
                            </Col>
                        </Row>
                    </Row>
                    <Form.Label><b>Total Cost:</b> ${(this.state.registrants.length * this.state.training.Cost).toFixed(2)}</Form.Label>
                    <Row>
                    {this.showButton()}
                    </Row>
                </Form>
            </div>
        );
    }
}

export default TraningRegistrationForm;

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}